// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Sx2zn","spin":"Spinner_spin__XiSBv"};